import Blue from "~/core";

new Blue({
  name: "ListTools",
  selector: ".list-tools",
  setup(listtools) {
    const tools = this;

    const select = () => {
      const items = [...tools.querySelectorAll('.list-tools__select')];
      const relations = [];
  
      const closeAll = e => {
        if (e.target.closest('.list-tools__select')) return;
        relations.forEach(r => r.close());
      };
  
      items.forEach(container => {
        let trigger = container.querySelector('.list-tools__select-active');
        let content = container.querySelector('.list-tools__select-menu');
        let config = {
          container,
          trigger,
          content,
          relations,
        };
        let select = new this.$toggle(config);
        relations.push(select);
      });
  
      window.addEventListener('click', closeAll);
    };
    select();
  },
});
